export default __webpack_public_path__ + "static/media/hht2_ep4_speaking_01.152edd7d.png";